import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Menu } from 'semantic-ui-react';

import { UnReadCountLabel } from './UnReadCountLabel';

export type Props = {
  unreadCount: number;
  markArticlesAsRead: () => void;
};

export const Announcement: React.FC<Props> = ({
  unreadCount,
  markArticlesAsRead,
}) => {
  const { t } = useTranslation();
  return (
    <Menu.Item
      className="announcement"
      href={t('pages.external.announcement.url')}
      link={true}
      onClick={markArticlesAsRead}
      rel="noopener noreferrer"
      target="_blank"
    >
      {unreadCount > 0 && <UnReadCountLabel unreadCount={unreadCount} />}
      <Icon name="bell" size="large" />
    </Menu.Item>
  );
};
